/* --------------------------------------------------------------------------
	Logo Scroll
-------------------------------------------------------------------------- */

"use strict";

import 'fastdom';

// When the user scrolls down 80px from the top of the document, add a new class to define the animation.
jQuery(document).ready(function($) {
  var top;
  
  function measureFunc() { 
    top = $(document).scrollTop() >= 160;
  }
  
  function mutateFunc() {
    if (top) {
      $('.logo_header').addClass('js-scrolling');
    } else {
      $('.logo_header').removeClass('js-scrolling');
    }
  }

  $(document).scroll(function() {
    fastdom.measure(measureFunc);
    fastdom.mutate(mutateFunc);
  });
});
